var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",attrs:{"id":"app"}},[_c('navigation',{staticClass:"follow"}),_c('router-view'),_c('fortherecord')],1)}
var staticRenderFns = []

export { render, staticRenderFns }